export const getDecimal = (number: number) => {
  let wholePart: number = Math.floor(number);
  return number - wholePart;
};
